import {DeleteIconButton} from '@/components/basic/buttons';
import AutocompleteArrayInput from '@/components/refinedev/AutocompleteArrayInput';
import SelectInput from '@/components/refinedev/SelectInput';
import TextInput from '@/components/refinedev/TextInput';
import {ProjectMemberTypes} from '../types';

const ProjectMemberInput = () => {
  return (
    <AutocompleteArrayInput
      source="members"
      reference="users"
      label="Nhân viên tham gia"
      autoCompleteProps={{optionText: 'name'}}
      renderSelectedItems={(items, removeAt) => {
        if (items.length === 0) return null;
        return (
          <table className="min-w-full divide-y divide-gray-200 mt-2">
            <thead className="bg-gray-100 py-2">
              <tr>
                <th
                  scope="col"
                  className="px-6 text-left text-xs font-medium text-gray-800 uppercase tracking-wider">
                  STT
                </th>
                <th
                  scope="col"
                  className="px-6 text-left text-xs font-medium text-gray-800 uppercase tracking-wider">
                  Tên nhân viên
                </th>
                <th
                  scope="col"
                  className="px-6 text-left text-xs font-medium text-gray-800 uppercase tracking-wider">
                  Vai trò trong dự án
                </th>
                <th
                  scope="col"
                  className="px-6 text-left text-xs font-medium text-gray-800 uppercase tracking-wider">
                  Hành động
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {items.map((item, index) => (
                <tr key={item.id} className="hover:bg-gray-50">
                  <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-800">{index + 1}</td>
                  <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-800">{item.name}</td>
                  <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-800">
                    <SelectInput
                      source={`members.${index}.pivot.role`}
                      choices={ProjectMemberTypes}
                    />
                  </td>
                  <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-800">
                    <DeleteIconButton
                      onClick={e => {
                        removeAt(index);
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      }}
    />
  );
};

export default ProjectMemberInput;
